import { DataProvider } from 'react-admin'
import { EngineMediaFileDto } from '../../dto/engine-media/engine-media-file.dto'

const fakeFiles: EngineMediaFileDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeFiles, total: fakeFiles.length }),
} as DataProvider

export default provider
